import { useDispatch } from "react-redux"
import { INotification } from "../../interfaces/notification/INotification";
import { NotificationActions } from "../../store/reducers/notificationSlice";

export const useNotification = () => {
    const dispatch = useDispatch();

    const displayNotification = (notification: INotification) => {
        dispatch(NotificationActions.addNotification(notification));
    }

    const clearNotification = () => {
        dispatch(NotificationActions.clearNotification());
    }

    return { displayNotification, clearNotification };
}